// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"844a97e1","219":"ec9324c6"}[chunkId] + ".chunk.js";
};